(function (m, $) {

    var grid;
    m.init = function () {
        grid = $(".people-card-container").masonry({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: ".card",
            // use element for option
            columnWidth: ".card",
            percentPosition: true,
            gutter: 24
        });

        $(".people-card-container").imagesLoaded().progress(function (instance, image) {
            grid.masonry("layout");
        });
    };

}(window.ooooby = window.ooooby || {}, jQuery));

$(document).ready(function () {
    ooooby.init();
});